import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { isWgsOrWes } from 'Common/utils/isWesWgs/isWesWgs';
import { useSelectedDatasetId } from 'Datasets/store';
import { WesWgsModelDefinitions } from './components/WesWgsModelDefinitions';
import { DefaultModelDefinitions } from './components/DefaultModelDefinitions';
const ModelDefinitions = ({ modelName }) => {
    const datasetId = useSelectedDatasetId();
    if (FEATURE_FLAGS.PUBLIC_VERSION && isWgsOrWes(datasetId)) {
        return (_jsx(WesWgsModelDefinitions, { modelName: modelName }, void 0));
    }
    return _jsx(DefaultModelDefinitions, { modelName: modelName }, void 0);
};
export default memo(ModelDefinitions);
